import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import {
  getFormattedContentInstreamPositionOptions,
  getFormattedContentOutstreamPositionOptions,
  getFormattedOnScreenPositionOptions
} from '../helpers'

import { dv360TargetingSelector } from '../../../../../../../modules/selectors/dv360Constants'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const PositionsSectionPreview = () => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const targeting = useSelector(dv360TargetingSelector)

  const formattedOnScreenPositionOptions = useMemo(() => getFormattedOnScreenPositionOptions(targeting), [targeting])
  const formattedInstreamPositionOptions = useMemo(
    () => getFormattedContentInstreamPositionOptions(targeting),
    [targeting]
  )
  const formattedOutstreamPositionOptions = useMemo(
    () => getFormattedContentOutstreamPositionOptions(targeting),
    [targeting]
  )

  return (
    <>
      <h3 className={classnames(drawerFormClasses.sectionTitle, classes.positionTitle)}>{t('Position on screen')}</h3>
      {formattedOnScreenPositionOptions.map(item => (
        <p>{item.label}</p>
      ))}
      <h3 className={classnames(drawerFormClasses.sectionTitle, classes.positionTitle)}>
        {t('Position in content (video in-stream)')}
      </h3>
      {formattedInstreamPositionOptions.map(item => (
        <p>{item.label}</p>
      ))}
      <h3 className={classnames(drawerFormClasses.sectionTitle, classes.positionTitle)}>
        {t('Position in content (video out-stream)')}
      </h3>
      {formattedOutstreamPositionOptions.map(item => (
        <p>{item.label}</p>
      ))}
    </>
  )
}

export default PositionsSectionPreview
